export default [
    {
        name: 'dashboard',
        label: 'Dashboard',
        permissionKey: 'dashboard_management',
        children: [
            {
                name: 'dashboard_fleet_vehicle_management',
                label: 'labels.fleetVehicleManagement',
                permissionKey: 'dashboard_fleet_vehicle_management'
            },

            {
                name: 'dashboard_fleet_operation',
                label: 'labels.fleetOperation',
                permissionKey: 'dashboard_fleet_operation'
            },
            {
                name: 'dashboard_direction_of_fleet',
                label: 'labels.directionOfFleet',
                permissionKey: 'dashboard_direction_of_fleet'
            },
            {
                name: 'dashboard_operation_shiment_leg',
                label: 'labels.operationShimentLeg',
                permissionKey: 'dashboard_operation_shiment_leg'
            },
            {
                name: 'dashboard_sale',
                label: 'Sales',
                permissionKey: 'dashboard_sale'
            }
        ]
    }
]
